module.exports = __webpack_public_path__ + "img/dianchi-80.82598b39.svg";